﻿import { useLocation } from 'react-router-dom';
import qs from 'query-string';

export default function useQueryParams() {
  return qs.parse(useLocation().search, {
    parseBooleans: true,
    parseNumbers: true,
  });
}
